// @ts-nocheck

import { memo, forwardRef, useState } from 'react'
import { Flex, Stack, Center, Image, Text, Button } from '@chakra-ui/react'

import { useUploadImage } from 'components/uploads/UploadImage/context/Provider'

type Props = {
  onDownload: () => void
}

const CropperConfigurations = forwardRef<any, Props>(({ onDownload }, ref) => {
  const { newImage, onUpload, closeModal, setView } = useUploadImage()

  const [isLoading, setIsLoading] = useState(false)

  const converImageURLToFile = async (imgUrl) => {
    const response = await fetch(imgUrl)
    const contentType = response.headers.get('content-type')
    const blob = await response.blob()
    return new File([blob], 'avatar', { contentType })
  }
  const handleOnUpload = async () => {
    if (!newImage.file) return

    const file = await converImageURLToFile(ref.current.src)

    setIsLoading(true)
    const isSuccess = await onUpload(file)
    if (isSuccess) closeModal()
    setIsLoading(false)
  }

  return (
    <Stack bg="light" p={2} align="center" justify="space-between" height="400px" maxHeight="400px" spacing={4}>
      <Flex w="100%" direction="column" align="center" justify="center" gap={2}>
        <Text>Visualização da imagem</Text>

        <Center width="max-content" flexDirection="column" borderWidth="5px" borderColor="primary" bg="transparent" rounded="lg">
          <Image rounded="sm" objectFit="cover" height="150px" maxHeight="150px" ref={ref} alt="Preview da imagem" />
        </Center>
      </Flex>

      <Stack w="100%" align="center" justify="center">
        <Button variant="ghost" w="100%" onClick={() => setView('Gallery')}>
          Voltar
        </Button>
        <Button variant="outline" w="100%" onClick={onDownload}>
          Baixar
        </Button>
        <Button isLoading={isLoading} w="100%" onClick={handleOnUpload}>
          Salvar
        </Button>
      </Stack>
    </Stack>
  )
})

export default memo(CropperConfigurations)
